import $ from 'jquery';
import 'what-input';
import SVGInjector from 'svg-injector-2';
import Prism from 'prismjs';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

// SVG Inject
document.addEventListener('DOMContentLoaded', function() {
  new SVGInjector().inject(document.querySelectorAll('svg[data-src]'));
});

/**
 * viewport height
 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// Get the language from the HTML lang attribute
const lang = document.documentElement.lang || 'en';

// Phone number mask
function phoneMask(event) {
  let input = event.target;
  let value = input.value.replace(/\D/g, '');

  if (lang === 'pt-br') {
    // Brazilian phone mask
    value = value.replace(/(^\d{2})(\d)/,'($1) $2');
    value = value.replace(/(\d{4,5})(\d{4}$)/,'$1-$2');
  } else {
    // International phone mask
    if (value.length > 0) value = '+' + value;
    value = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
  }

  input.value = value;
}

// Document/Tax ID mask
function documentMask(event) {
  let input = event.target;
  let value = input.value.replace(/\D/g, '');

  if (lang === 'pt-br') {
    // CPF/CNPJ mask
    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
      value = value.replace(/^(\d{2})(\d)/, '$1.$2');
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
      value = value.replace(/(\d{4})(\d)/, '$1-$2');
    }
  } else {
    // Generic Tax ID mask (allows up to 20 characters)
    value = value.replace(/(\d{3})(?=\d)/g, '$1 ');
  }

  input.value = value.substring(0, 20);
}

// Zip/Postal Code mask
function zipMask(event) {
  let input = event.target;
  let value = input.value.replace(/\D/g, '');

  if (lang === 'pt-br') {
    // CEP mask
    value = value.replace(/^(\d{5})(\d)/, '$1-$2');
  } else {
    // Generic ZIP mask (allows up to 10 characters)
    value = value.replace(/(\d{3})(?=\d)/g, '$1 ');
  }

  input.value = value.substring(0, 10);
}

// Apply masks to inputs
if (document.getElementById('phone')) {
  document.getElementById('phone').addEventListener('input', phoneMask);
}

if (document.getElementById('document')) {
  document.getElementById('document').addEventListener('input', documentMask);
}

if (document.getElementById('zip')) {
  document.getElementById('zip').addEventListener('input', zipMask);
}

// List of countries (you may want to move this to a separate file)
const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czechia", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

// Spanish country names
const countriesEs = [
  "Afganistán", "Albania", "Argelia", "Andorra", "Angola", "Antigua y Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaiyán", "Bahamas", "Baréin", "Bangladés", "Barbados", "Bielorrusia", "Bélgica", "Belice", "Benín", "Bután", "Bolivia", "Bosnia y Herzegovina", "Botsuana", "Brasil", "Brunéi", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Camboya", "Camerún", "Canadá", "República Centroafricana", "Chad", "Chile", "China", "Colombia", "Comoras", "Congo (Congo-Brazzaville)", "Costa Rica", "Costa de Marfil", "Croacia", "Cuba", "Chipre", "República Checa", "República Democrática del Congo", "Dinamarca", "Yibuti", "Dominica", "República Dominicana", "Ecuador", "Egipto", "El Salvador", "Guinea Ecuatorial", "Eritrea", "Estonia", "Esuatini", "Etiopía", "Fiyi", "Finlandia", "Francia", "Gabón", "Gambia", "Georgia", "Alemania", "Ghana", "Grecia", "Granada", "Guatemala", "Guinea", "Guinea-Bisáu", "Guyana", "Haití", "Honduras", "Hungría", "Islandia", "India", "Indonesia", "Irán", "Iraq", "Irlanda", "Israel", "Italia", "Jamaica", "Japón", "Jordania", "Kazajistán", "Kenia", "Kiribati", "Kosovo", "Kuwait", "Kirguistán", "Laos", "Letonia", "Líbano", "Lesoto", "Liberia", "Libia", "Liechtenstein", "Lituania", "Luxemburgo", "Madagascar", "Malaui", "Malasia", "Maldivas", "Malí", "Malta", "Islas Marshall", "Mauritania", "Mauricio", "México", "Micronesia", "Moldavia", "Mónaco", "Mongolia", "Montenegro", "Marruecos", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Países Bajos", "Nueva Zelanda", "Nicaragua", "Níger", "Nigeria", "Corea del Norte", "Macedonia del Norte", "Noruega", "Omán", "Pakistán", "Palaos", "Estado de Palestina", "Panamá", "Papúa Nueva Guinea", "Paraguay", "Perú", "Filipinas", "Polonia", "Portugal", "Catar", "Rumania", "Rusia", "Ruanda", "San Cristóbal y Nieves", "Santa Lucía", "San Vicente y las Granadinas", "Samoa", "San Marino", "Santo Tomé y Príncipe", "Arabia Saudita", "Senegal", "Serbia", "Seychelles", "Sierra Leona", "Singapur", "Eslovaquia", "Eslovenia", "Islas Salomón", "Somalia", "Sudáfrica", "Corea del Sur", "Sudán del Sur", "España", "Sri Lanka", "Sudán", "Surinam", "Suecia", "Suiza", "Siria", "Tayikistán", "Tanzania", "Tailandia", "Timor Oriental", "Togo", "Tonga", "Trinidad y Tobago", "Túnez", "Turquía", "Turkmenistán", "Tuvalu", "Uganda", "Ucrania", "Emiratos Árabes Unidos", "Reino Unido", "Estados Unidos de América", "Uruguay", "Uzbekistán", "Vanuatu", "Ciudad del Vaticano", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabue"
];

// List of Brazilian states
const brazilianStates = [
  "Acre", "Alagoas", "Amapá", "Amazonas", "Bahia", "Ceará", "Distrito Federal",
  "Espírito Santo", "Goiás", "Maranhão", "Mato Grosso", "Mato Grosso do Sul",
  "Minas Gerais", "Pará", "Paraíba", "Paraná", "Pernambuco", "Piauí",
  "Rio de Janeiro", "Rio Grande do Norte", "Rio Grande do Sul", "Rondônia",
  "Roraima", "Santa Catarina", "São Paulo", "Sergipe", "Tocantins"
];

function initializeAutocomplete(inputId, listId, dataArray) {
  const input = document.getElementById(inputId);
  const list = document.getElementById(listId);
  
  if (!input || !list) return; // Exit if elements are not found

  input.addEventListener('input', function() {
    const value = this.value.toLowerCase();
    const matches = dataArray.filter(item => 
      item.toLowerCase().startsWith(value)
    );

    // Clear previous results
    list.innerHTML = '';

    // Add new results
    matches.forEach((match, index) => {
      const li = document.createElement('li');
      li.textContent = match;
      li.setAttribute('role', 'option');
      li.id = `${inputId}-option-${index}`;
      li.addEventListener('click', function() {
        input.value = match;
        list.innerHTML = '';
        list.style.display = 'none'; // Hide list after selection
      });
      list.appendChild(li);
    });

    // Show/hide the autocomplete list
    if (matches.length && value.length) {
      list.style.display = 'block';
    } else {
      list.style.display = 'none';
    }
  });

  // Handle keyboard navigation
  input.addEventListener('keydown', function(e) {
    const items = list.getElementsByTagName('li');
    let index = Array.from(items).findIndex(item => item.classList.contains('selected'));

    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (index < items.length - 1) index++;
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (index > 0) index--;
        break;
      case 'Enter':
        e.preventDefault();
        if (index > -1) {
          input.value = items[index].textContent;
          list.innerHTML = '';
          list.style.display = 'none';
        }
        return;
      case 'Escape':
        list.innerHTML = '';
        input.value = '';
        list.style.display = 'none';
        return;
      default:
        return;
    }

    Array.from(items).forEach(item => item.classList.remove('selected'));
    if (index > -1) {
      items[index].classList.add('selected');
      input.setAttribute('aria-activedescendant', items[index].id);
    }
  });

  // Hide autocomplete list when clicking outside
  document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && !list.contains(e.target)) {
      list.style.display = 'none';
      list.innerHTML = ''; // Clear the list when hiding
    }
  });
}

// Call these functions when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const lang = document.documentElement.lang || 'en';

  // Initialize country autocomplete
  if (document.getElementById('country')) {
    initializeAutocomplete('country', 'country-list', lang === 'es' ? countriesEs : countries);
  }

  if (lang === 'pt' || lang === 'pt-br') {
    // Initialize state autocomplete for Portuguese
    initializeAutocomplete('state', 'state-list', brazilianStates);
  } else {
    // Initialize country autocomplete for English
    // initializeAutocomplete('country', 'country-list', countries);
  }

  // Initialize Foundation
  $(document).foundation();

  // Check if current date is within holiday period
  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), 11, 23); // December 23th
  const endDate = new Date(currentDate.getFullYear() + 1, 0, 6);  // January 6th next year
  
  if (currentDate >= startDate && currentDate <= endDate) {
    console.log('Holiday Break');
    // Check if user has already closed the popup
    const hasClosedPopup = localStorage.getItem('holidayPopupClosed');
    
    if (!hasClosedPopup) {
      // Show holiday popup
      $('#holiday-popup-alert').foundation('open');
      
      // Add event listener for popup close
      $('#holiday-popup-alert').on('closed.zf.reveal', function() {
        localStorage.setItem('holidayPopupClosed', 'true');
      });
    }
  }
});

$(function() {
  // Smooth Scroll
  Foundation.SmoothScroll.defaults.animationEasing = 'swing';

  // Target blank
  $('a[rel="external"]').attr('target', '_blank');

  // Ajax default error
  $.ajaxSetup({
    error: AjaxError
  });

  function AjaxError(x, e) {
    if (x.status == 0) {
      console.warn(' Check Your Network.');
    } else if (x.status == 404) {
      console.warn('Requested URL not found.');
    } else if (x.status == 500) {
      console.warn('Internel Server Error.');
    } else {
      console.warn('Unknow Error.\n' + x.responseText);
    }
  }

  // Testimonials

  // shuffle array
  function knuthShuffle(arr) {
    var rand, temp, i;

    for (i = arr.length - 1;i > 0;i -= 1) {
      rand = Math.floor((i + 1) * Math.random());//get random between zero and i (inclusive)
      temp = arr[rand];//swap i and the zero-indexed number
      arr[rand] = arr[i];
      arr[i] = temp;
    }
    return arr;
  }

  function updateTestimonials(target) {
    let $link = $('a.clients-testimonials__brand');
    let $item = $('.clients-testimonials__brand[href="' + target + '"]');
    let $pagination = $('.clients-testimonials__testimonial__pagination__step[data-testimonial="' + target.replace('#', '') + '"]');

    $link.removeClass('active');
    $item.addClass('active');
    $(target).siblings().removeClass('active');
    $(target).addClass('active');
    $pagination.siblings().removeClass('active');
    $pagination.addClass('active');
  }

  let testimonialsData = 'assets/api/clients.json';
  
  $.get(testimonialsData, function (data) {
    let limit = 9;
    let clients = knuthShuffle(data['clients']);
    let brand;
    let $column;
    let $pagination = $('.clients-testimonials__testimonial__pagination');
    let page;

    $('.clients-testimonials__container').removeClass('loading');

    for(let index in clients){
      if(index <= limit){
        let client = clients[index];
        let $container = $('.clients-testimonials__testimonial__container');
        
        // brand structure

          // check if it's 5th or below
          $column = (index < limit / 2) ? $('.clients-testimonials__left') : $('.clients-testimonials__right');

          if (client.testimonial) {
            brand = `<a class="clients-testimonials__brand" href="#testimonial-${index}" title="What ${client.company} says about us">`;
          } else {
            brand = `<a class="clients-testimonials__brand clients-testimonials__brand--no-testimonial" href="${client.url}" rel="external noreferrer noopener" target="_blank" title="Visit ${client.company} website">`;
          }
          
          if (client.testimonial) {
            brand += client.brand.endsWith("svg") ? `<svg data-src="${client.brand}" />` : `<img src="${client.brand}" alt="${client.company} brand">`;
          } else {
            brand += client.brand.endsWith("svg") ? `<svg class="desaturate" data-src="${client.brand}" />` : `<img class="desaturate" src="${client.brand}" alt="${client.company} brand">`;
          }

          brand += `<span class="show-for-sr">${client.company}</span>`;
          brand += `</a>`;
        
        
        // testimonials
        let testimonial;
        if(client.testimonial && $('html').attr('lang') == 'pt-br'){
          testimonial = `<div id="testimonial-${index}" class="clients-testimonials__testimonial">
            <div class="stripe" aria-hidden="true"></div>
            <div class="clients-testimonials__testimonial__profile grid-x align-middle">
              <div class="shrink cell">
                <img src="${client.photo}" alt="${client.name}'s photo'">
              </div>
              <div class="auto cell">
                <h6>${client.name}</h6>
                <p>${client.role_pt}</p>
              </div>
            </div>
      
            <blockquote cite="${client.url}">
              <p>${client.testimonial_pt}</p>
            </blockquote>

            <a href="${client.url}" rel="external" title="Visit ${client.company} website">
              <img class="clients-testimonials__testimonial__brand" src="${client.brand}" alt="${client.company} brand">
            </a>
          </div>`;
        } else if(client.testimonial && $('html').attr('lang') == 'es') {
          testimonial = `<div id="testimonial-${index}" class="clients-testimonials__testimonial">
            <div class="stripe" aria-hidden="true"></div>
            <div class="clients-testimonials__testimonial__profile grid-x align-middle">
              <div class="shrink cell">
                <img src="${client.photo}" alt="${client.name}'s photo'">
              </div>
              <div class="auto cell">
                <h6>${client.name}</h6>
                <p>${client.role_es}</p>
              </div>
            </div>
      
            <blockquote cite="${client.url}">
              <p>${client.testimonial_es}</p>
            </blockquote>

            <a href="${client.url}" rel="external" title="Visit ${client.company} website">
              <img class="clients-testimonials__testimonial__brand" src="${client.brand}" alt="${client.company} brand">
            </a>
          </div>`;
        } else if(client.testimonial) {
          testimonial = `<div id="testimonial-${index}" class="clients-testimonials__testimonial">
            <div class="stripe" aria-hidden="true"></div>
            <div class="clients-testimonials__testimonial__profile grid-x align-middle">
              <div class="shrink cell">
                <img src="${client.photo}" alt="${client.name}'s photo'">
              </div>
              <div class="auto cell">
                <h6>${client.name}</h6>
                <p>${client.role}</p>
              </div>
            </div>
      
            <blockquote cite="${client.url}">
              <p>${client.testimonial}</p>
            </blockquote>

            <a href="${client.url}" rel="external" title="Visit ${client.company} website">
              <img class="clients-testimonials__testimonial__brand" src="${client.brand}" alt="${client.company} brand">
            </a>
          </div>`;
        }

        // pagination
        if(client.testimonial){
          page = `<span class="clients-testimonials__testimonial__pagination__step auto cell" data-testimonial="testimonial-${index}"></span>`;
          $pagination.append(page);
        }

        $column.append(brand);
        $container.append(testimonial);
      }
    }

    // interactions
    let $link = $('a.clients-testimonials__brand');
    let $testimonial = $('.clients-testimonials__testimonial');
    let $paginationStep = $('.clients-testimonials__testimonial__pagination__step');

    // randomly activates one testimonial
    let getRandomInt = function (min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    }

    let testimonialIndex = getRandomInt(1, $testimonial.length); // starting with 1 because the pagination is the first element

    let activeTestmonial = $testimonial.eq(testimonialIndex);
    activeTestmonial.addClass('active');

    let anchor = activeTestmonial.attr('id');
    $('a.clients-testimonials__brand[href="#' + anchor + '"]').addClass('active');

    $paginationStep.eq(testimonialIndex).addClass('active');

    $link.on('click', function (e) {
      if(!$(this).hasClass('clients-testimonials__brand--no-testimonial')){
        e.preventDefault();
        updateTestimonials($(this).attr('href'));
      }
    });

    $paginationStep.on('click', function () {
      updateTestimonials('#' + $(this).attr('data-testimonial'));
    });

    setTimeout(() => {
      new SVGInjector().inject(document.querySelectorAll('.clients-testimonials .clients-testimonials__brand svg[data-src]'));
    }, 1000);
  });

  // forms
  let $formContact = $('form.contact__form');

  if(!$formContact.hasClass('contact__form--client') && !$formContact.hasClass('contact__form--hours')){
    $formContact
    .on('formvalid.zf.abide', function (ev, frm) {
      // console.log("Form id " + frm.attr('id') + " is valid");
      showLoading(ev.target);
      const formContact = document.forms['contact'];

      fetch('https://n8n.coopers.pro/webhook/contato-coopers', { method: "POST", body: new FormData(formContact) })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response;
        })
        .then(() => showSuccess(frm))
        .catch(error => showError(frm, error.message));
    })
    .on('forminvalid.zf.abide', function(ev, frm) {
      // console.log("Form id " + ev.target.id + " is invalid");
      $('.resultado-form', ev.target).addClass('hide');
      showError(ev.target);
    })
    .on('submit', function(ev) {
      ev.preventDefault();
      // console.log('Submit for form id ' + ev.target.id + ' intercepted');
    });
  }

  $('.toggle-select input[type="radio"]').on('change', function(){
    let $parent = $(this).closest('li');
    let $select = $parent.find('select');
    if($(this).is(':checked')){
      $select.removeClass('is-hidden');
    }
    $('select', $parent.siblings()).addClass('is-hidden').val('');
  })


  // Clients Information - Send to spreadsheet
  let $formClient = $('form.contact__form--client');

  $formClient
  .on('formvalid.zf.abide', function (ev, frm) {
    showLoading(ev.target);
    const formClient = document.forms['client-information'];
    const formData = new FormData(formClient);
    
    // Add language information to FormData
    const lang = $('html').attr('lang') || 'en';
    formData.append('language', lang);

    // Add formatted date and time
    const now = new Date();
    const formattedDateTime = now.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(',', ' -');
    formData.append('submissionDateTime', formattedDateTime);

    fetch('https://n8n.coopers.pro/webhook/dados-cadastrais', { method: "POST", body: formData })
      .then(response => showSuccess(frm))
      .catch(error => showError(frm, error.message));
  })
  .on('forminvalid.zf.abide', function(ev, frm) {
    // console.log("Form id " + ev.target.id + " is invalid");
    $('.resultado-form', ev.target).addClass('hide');
    showError(ev.target);
  })
  .on('submit', function(ev) {
    ev.preventDefault();
    // console.log('Submit for form id ' + ev.target.id + ' intercepted');
  });

  // Additional Hours - Send to API
  let $formHours = $('form.contact__form--hours');

  $formHours
  .on('formvalid.zf.abide', function (ev, frm) {
    // console.log("Form id " + frm.attr('id') + " is valid");
    showLoading(ev.target);
    const formHours = document.forms['additional-hours'];

    fetch('https://n8n.coopers.pro/webhook/horas-adicionais', { method: "POST", body: new FormData(formHours) })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response;
      })
      .then(() => showSuccess(frm))
      .catch(error => showError(frm, error.message));
  })
  .on('forminvalid.zf.abide', function(ev, frm) {
    // console.log("Form id " + ev.target.id + " is invalid");
    $('.resultado-form', ev.target).addClass('hide');
    showError(ev.target);
  })
  .on('submit', function(ev) {
    ev.preventDefault();
    // console.log('Submit for form id ' + ev.target.id + ' intercepted');
  });

  let showLoading = function(form) {
    $('button[type=submit]', form).prop('disabled', true).addClass('loading');
  }

  let showSuccess = function(form) {
    showLoading(form);
    $('.resultado-form', form).removeClass('hide');
    form[0].reset();
    $('button[type=submit]', form).prop('disabled', false).removeClass('loading');
  }
  
  let showError = function(form, message) {
    $('button[type=submit]', form).prop('disabled', false).removeClass('loading');
    if(message && typeof(message) !== undefined) {
      console.log(message);
    } else {
      $('[data-abide-error]', form).removeAttr('style');
    }
  }

  // Coopers Shop - App
  
    // Show options for Categories and Product if user clicks on the "Selecionados" radio option
    $('.selecting-restricted .general-selection input:radio').change(function(){
      if ( $(".selecting-restricted .general-selection input#just-selected").is(':checked') ) {
        $('.selecting-restricted .options-for-select').removeClass('hide');
      } else {
        $('.selecting-restricted .options-for-select').addClass('hide');
      }
    });
    
    // Cancel App
    $('#confirm').click(function () {
      //check if checkbox is checked
      if ($(this).is(':checked')) {
        $('#cancel-app__button').removeAttr('disabled'); //enable cancel button
      } else {
        $('#cancel-app__button').attr('disabled', true); //disable cancel button
      }
    });

});
